import React, { useMemo } from 'react'
import QualysWebappMappingForm_v1 from './QualysWebappMappingForm_v1';
import QualysWebappCredentialsForm from './QualysWebappCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData } from 'utils/tableUtils';

export default function QualysWebappConfigListing(props) {
    const columns = useMemo(() => [
        {
            title: "App Name",
            dataIndex: "appName",
            width: 240,
            render: columnRenderArrayData
        },
        {
            title: "Tag Name",
            dataIndex: "tagName",
            width: 240,
            render: columnRenderArrayData
        }
    ], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={QualysWebappMappingForm_v1}
            CredentialsForm={QualysWebappCredentialsForm}
            extraColumns={columns}
        />
    )
}